import { useTranslation } from 'react-i18next';
import { CHANNEL_TEST_IDS } from '@connect-x-app/web-test-ids';
import { Modal, ModalOpener } from '@connect-x-app/web-ui';

import { QuickReplyButton } from './QuickReplyButton';

import './quickRepliesModal.scss';

type Props = {
  onPressQuickReply: (quickReply: string) => void;
  quickReplies: string[];
};

export const QuickRepliesModal = ({ onPressQuickReply, quickReplies }: Props) => {
  const { t } = useTranslation();

  const onSelectQuickReply = (quickReply: string) => {
    onPressQuickReply(quickReply);
    ModalOpener.instance.close();
  };

  return (
    <Modal className="quick-replies-modal" testId={CHANNEL_TEST_IDS.quickReplies.modal}>
      <Modal.Header>{t('CHAT.QUICK_REPLIES.MODAL.TITLE')}</Modal.Header>
      <Modal.Content>
        <div className="quick-replies-modal__list">
          {quickReplies.map(quickReply => (
            <QuickReplyButton key={quickReply} onClick={() => onSelectQuickReply(quickReply)} quickReply={quickReply} />
          ))}
        </div>
      </Modal.Content>
    </Modal>
  );
};
